import { Component, Input } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { MenuItem } from 'primeng/api';


@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [MenuComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

  @Input()
  model!: MenuItem[]
}
